function LinkIcon(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M4.23223 7.17849L3.05372 5.99998C2.64615 5.59242 2.44236 5.10137 2.44236 4.52684C2.44236 3.95232 2.64615 3.46127 3.05372 3.05371C3.46128 2.64614 3.95233 2.44235 4.52686 2.44235C5.10138 2.44235 5.59243 2.64614 5.99999 3.05371L7.17851 4.23222L6.58925 4.82147L5.41074 3.64296C5.16522 3.39744 4.87059 3.27468 4.52686 3.27468C4.18312 3.27468 3.8885 3.39744 3.64297 3.64296C3.39745 3.88848 3.27469 4.18311 3.27469 4.52684C3.27469 4.87058 3.39745 5.1652 3.64297 5.41073L4.82148 6.58924L4.23223 7.17849ZM4.52686 5.1161L5.11611 4.52684L7.47313 6.88387L6.88388 7.47312L4.52686 5.1161ZM4.82148 7.76775L5.41074 7.17849L6.58925 8.35701C6.83477 8.60253 7.1294 8.72529 7.47313 8.72529C7.81687 8.72529 8.11149 8.60253 8.35702 8.35701C8.60254 8.11148 8.7253 7.81686 8.7253 7.47312C8.7253 7.12939 8.60254 6.83476 8.35702 6.58924L7.17851 5.41073L7.76776 4.82147L8.94627 5.99998C9.35384 6.40755 9.55763 6.8986 9.55763 7.47312C9.55763 8.04765 9.35384 8.53869 8.94627 8.94626C8.5387 9.35383 8.04766 9.55761 7.47313 9.55761C6.89861 9.55761 6.40756 9.35383 5.99999 8.94626L4.82148 7.76775Z" />
    </svg>
  )
}

export default LinkIcon
